"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CloseIcon = function CloseIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.0824 5.87575C13.7571 5.55037 13.2295 5.55034 12.9041 5.87568L9.95747 8.82162L7.01164 5.87579C6.68625 5.5504 6.15869 5.5504 5.83331 5.87579C5.50792 6.20118 5.50792 6.72873 5.83331 7.05412L8.77914 9.99995L5.83331 12.9458C5.50792 13.2712 5.50792 13.7987 5.83331 14.1241C6.15869 14.4495 6.68625 14.4495 7.01164 14.1241L9.95747 11.1783L12.9041 14.1242C13.2295 14.4496 13.7571 14.4495 14.0824 14.1242C14.4078 13.7987 14.4078 13.2712 14.0824 12.9458L11.1366 9.99995L14.0824 7.05416C14.4078 6.72875 14.4078 6.20116 14.0824 5.87575Z",
    fill: color
  }));
};

var _default = CloseIcon;
exports.default = _default;